import React from "react";
import styled from "styled-components";
import { SecondaryButton } from "../UI/Button/Button";
import DropDownCheckboxForm, { DropDownCheckboxOption } from "./DropDownCheckboxFilter";
import DateRangePicker from "./DateRangePicker";
import { Device } from "../../../components/device";
import { connect } from "react-redux";
import { AppState, AppThunkDispatch } from "../../../store";
import { thunkResetFilters, thunkUpdateFilters, ShowFilters } from "../../../store/shows/action";
import { getShowCategories, getShowFilters, getShows } from "../../../store/shows";

const WebFilterRow = styled.section`
    justify-content: flex-start;
    align-items: flex-end;
    padding-right: 145px;
    margin-bottom: 3rem;
    display: none;
    ${Device.tablet} {
        display: flex;
    }
    .webfilter__reset {
        position: absolute;
        right: 0;
    }
`;

const WebFilterCol = styled.div`
    padding-left: 1.5rem;
    &:first-child {
        padding-left: 0;
    }
    ${Device.laptop} {
        padding-left: 3rem;
    }
`;

const WebFilter: React.FC<WebFilterStateProps> = (props) =>
{
    const resetFilters = () =>
    {
        props.resetFilters();
    };

    const updateSelectedShowNames = (options: DropDownCheckboxOption[]) =>
    {
        const selectedValues = options.filter((opt) => opt.selected).map((opt) => opt.value);
        props.updateFilters({ ...props.filters, shows: selectedValues });
    };

    const updateSelectedDates = (startDate?: Date, endDate?: Date) =>
    {
        props.updateFilters({ ...props.filters, startDate: startDate, endDate: endDate });
    };

    const handleCategoryChange = (options: DropDownCheckboxOption[]) =>
    {
        const values = options.filter(opt => opt.selected).map((opt) => opt.value);
        props.updateFilters({ ...props.filters, categories: values });
    };

    return (
        <WebFilterRow>
            {props.categories.length > 0 ? (
                <WebFilterCol>
                    <DropDownCheckboxForm
                        label="Kategori"
                        options={props.categories.map((s) => ({
                            label: s,
                            value: s,
                            selected: props.filters.categories.includes(s)
                        }))}
                        onChange={handleCategoryChange}
                    />
                </WebFilterCol>
            ) : null}
            <WebFilterCol>
                <DropDownCheckboxForm
                    label="Forestillinger"
                    options={props.allShows.map((s) => ({
                        label: s.name,
                        value: s.name,
                        selected: props.filters.shows.includes(s.name)
                    }))}
                    onChange={updateSelectedShowNames}
                />
            </WebFilterCol>
            <WebFilterCol>
                <DateRangePicker
                    startDate={props.filters.startDate}
                    endDate={props.filters.endDate}
                    onSubmit={updateSelectedDates}
                    startDateLabel="Start dato"
                    endDateLabel="Slut dato"
                />
            </WebFilterCol>
            <WebFilterCol className="webfilter__reset">
                <SecondaryButton onClick={resetFilters} className="uppercase mb-0" size="small">
                    Nulstil Filtre
                </SecondaryButton>
            </WebFilterCol>
        </WebFilterRow>
    );
};

const mapStateToProps = (state: AppState) => ({
    filters: getShowFilters(state.shows),
    categories: getShowCategories(state.shows),
    allShows: getShows(state.shows)
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
    resetFilters: () => dispatch(thunkResetFilters()),
    updateFilters: (filters: ShowFilters) => dispatch(thunkUpdateFilters(filters))
});

type WebFilterStateProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(WebFilter);